import React from "react";
import Link from "../Link";
import styles from "./styles.css";
const appleStoreIcon = require("../../assets/AppleStore.png");
const googlePlayIcon = require("../../assets/GooglePlay.png");
function StoreLinks({ appStoreUrl, playMarketUrl }) {
    return (React.createElement("section", { className: styles.container },
        React.createElement(Link, { href: appStoreUrl, className: styles.link, content: React.createElement("img", { src: appleStoreIcon, alt: "App Store" }) }),
        playMarketUrl && (React.createElement(Link, { href: playMarketUrl, className: styles.link, content: React.createElement("img", { src: googlePlayIcon, alt: "Google Play" }) }))));
}
;
export default StoreLinks;
